import { render } from "./users-authorization.vue?vue&type=template&id=7cb88f3f&scoped=true&ts=true"
import script from "./users-authorization.vue?vue&type=script&lang=ts"
export * from "./users-authorization.vue?vue&type=script&lang=ts"

import "./users-authorization.vue?vue&type=style&index=0&id=7cb88f3f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cb88f3f"]])

export default __exports__